import React from 'react';
import './input.css';

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  helperText?: string | React.ReactNode;
  leftIcon?: React.ReactNode;
  rightIcon?: React.ReactNode;
  fullWidth?: boolean;
}

export const Input: React.FC<InputProps> = ({
  label,
  error,
  helperText,
  leftIcon,
  rightIcon,
  fullWidth = true,
  className = '',
  id,
  ...props
}) => {
  const inputId = id || `input-${Math.random().toString(36).substr(2, 9)}`;
  const hasError = !!error;

  return (
    <div className={`input-wrapper ${fullWidth ? 'input-wrapper--full' : ''} ${className}`}>
      {label && (
        <label htmlFor={inputId} className="input-label">
          {label}
        </label>
      )}
      
      <div className={`input-container ${hasError ? 'input-container--error' : ''}`}>
        {leftIcon && <div className="input-icon input-icon--left">{leftIcon}</div>}
        
        <input
          id={inputId}
          className={`input ${leftIcon ? 'input--with-left-icon' : ''} ${rightIcon ? 'input--with-right-icon' : ''}`}
          {...props}
        />
        
        {rightIcon && <div className="input-icon input-icon--right">{rightIcon}</div>}
      </div>
      
      {error && <span className="input-error">{error}</span>}
      {!error && helperText && <span className="input-helper">{helperText}</span>}
    </div>
  );
};